import React from "react";
import { Sparkles, Lightbulb, ArrowUpRight } from "lucide-react";
import { parseAnswer } from "../../lib/searchApi";
import { cn } from "../../lib/utils";

const LEVEL = {
  HIGH: "bg-critical/10 text-critical border-critical/30",
  MEDIUM: "bg-warning/10 text-warning border-warning/30",
  LOW: "bg-info/10 text-info border-info/30",
};

function Pulse() {
  return <span className="inline-block w-1.5 h-3.5 align-middle ml-0.5 bg-primary/70 animate-pulse" aria-hidden />;
}

export function AiAnswer({ text, streaming }) {
  const a = parseAnswer(text);
  const empty = !a.summary && !a.insights.length && !a.recs.length;
  return (
    <section data-testid="ai-search-answer" className="space-y-4">
      <div className="border-l-2 border-primary pl-3.5">
        <div className="text-[10px] uppercase tracking-[0.2em] text-primary font-semibold mb-1 inline-flex items-center gap-1.5"><Sparkles size={11} /> Summary</div>
        <p data-testid="ai-search-summary" className="text-[14px] leading-relaxed">
          {empty ? <span className="text-muted">Claude Opus 5.5 is reading the figures…</span> : a.summary}
          {streaming && !a.insights.length && <Pulse />}
        </p>
      </div>
      {a.insights.length > 0 && (
        <div>
          <div className="kpi-label text-[10px] mb-2">Insights</div>
          <ul className="space-y-2" data-testid="ai-search-insights">
            {a.insights.map((t, i) => (
              <li key={i} data-testid={`ai-search-insight-${i}`} className="flex gap-2.5 text-[13px] leading-relaxed animate-fade-in">
                <Lightbulb size={13} className="text-primary shrink-0 mt-1" /><span>{t}{streaming && !a.recs.length && i === a.insights.length - 1 && <Pulse />}</span>
              </li>
            ))}
          </ul>
        </div>
      )}
      {a.recs.length > 0 && (
        <div>
          <div className="kpi-label text-[10px] mb-2">Recommendations</div>
          <div className="space-y-2" data-testid="ai-search-recommendations">
            {a.recs.map((r, i) => (
              <div key={i} data-testid={`ai-search-rec-${i}`} className="tile px-3.5 py-3 flex gap-3 items-start animate-fade-in">
                <span className={cn("shrink-0 text-[10px] font-semibold uppercase tracking-wider border rounded-sm px-1.5 py-0.5", LEVEL[r.level] || "bg-surface-2 text-muted border-border")}>
                  {r.level || "Next"}
                </span>
                <span className="text-[13px] leading-relaxed flex-1">{r.text}{streaming && i === a.recs.length - 1 && <Pulse />}</span>
                <ArrowUpRight size={13} className="text-subtle shrink-0 mt-1" />
              </div>
            ))}
          </div>
        </div>
      )}
    </section>
  );
}
